import type { ResourceContext } from '../types';

// Live resource-creation signal. useChatWs emits here when a `create` resource frame arrives over
// the socket — which only happens for live frames, never during the `ready` history replay — and
// the chat widget's fly-to-explorer animation listens. A bus (rather than prop-threading) keeps the
// socket hook decoupled from the widget that owns the toggle + badge, and means backlog/replayed
// resources never animate because they simply never emit.
export type ArrivalOrigin = { chatSessionId?: string; isLive?: boolean };

type ArrivalListener = (key: string, kind: ResourceContext['kind'], origin: ArrivalOrigin) => void;

const listeners = new Set<ArrivalListener>();

export const notifyResourceArrival = (key: string, kind: ResourceContext['kind'], origin: ArrivalOrigin = {}) => {
  for (const listener of listeners) listener(key, kind, origin);
};

export const subscribeResourceArrival = (listener: ArrivalListener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
